/**
 * Results overlay - allows users to request email notification of their results
 */
import classnames from 'classnames';
import React, { PropTypes } from 'react';

function ResultsOverlay({ emailResults, emailSent, resultUserEmail, setResult }) {
  const updateEmail = (evt) => {
    const newEmail = evt.target.value;
    setResult({ resultUserEmail: newEmail });
  };
  const onClick = () => setResult({ resultsOverlay: false });
  return (
    <div
      className={classnames({
        'results-overlay': true,
      })}
    >
      <div
        className={classnames({
          'results-email': true,
        })}
      >
        <button
          className="close-window"
          onClick={onClick}
        >
          &times;
        </button>
        <h4>
          Email me my results
        </h4>
        <div>
          <input
            defaultValue={resultUserEmail}
            onChange={updateEmail}
            placeholder="Type your email"
            type="email"
          />
        </div>
        {emailSent ?
          <div>
            Your email has been sent!
          </div>
        :
          <button
            disabled={!resultUserEmail}
            onClick={emailResults}
          >
            Send Now
          </button>
        }
      </div>
    </div>
  );
}

ResultsOverlay.propTypes = {
  emailResults: PropTypes.func,
  emailSent: PropTypes.bool,
  resultUserEmail: PropTypes.string,
  setResult: PropTypes.func,
};

export default ResultsOverlay;



// WEBPACK FOOTER //
// js/src/goals/ResultsOverlay.js